import Application from './Application';
import BaseView from './views/BaseView';
import DomainModel from './DomainModel';
import EventDispatcher from './EventDispatcher';
import logging from './logging';

const log = logging('selection');


export default class SelectionManager extends EventDispatcher {
    view?: BaseView;
    model?: DomainModel;

    private app: Application;

    constructor(app: Application) {
        super();
        this.app = app;
    }

    set(selection: BaseView)
    {
        log.trace("SelectionManager.set()");

        // No need to do anything if this is a no-op.
        if(selection == this.view) return;

        this.clear();
        this.view = selection;
        this.model = selection.model;

        for(let mesh of selection.highlights) {
            if(mesh.userData.isSectionHit) {
                mesh.visible = true;
            }
            // highlight objects go on layer 1 (mask 0b10)
            mesh.layers.set(1);
        }

        this.trigger('set');
    }

    /**
     * Clears the current highlight.
     */
    clear()
    {
        log.debug("SelectionManager.clear()");
        if(this.view) {
            for(let mesh of this.view.highlights) {
                if(mesh.userData.isSectionHit) {
                    mesh.visible = false;
                }
                // regular objects go on layer 0 (mask 0b01)
                mesh.layers.set(0);
            }
        }
        delete this.view;
        delete this.model;
        this.app.pipeline.update = true;

        this.trigger('clear');
    }
}
